<template>
  <div class="event-stat-view">
    <MForm v-bind="formConfig" :model="formModel" />

    <el-row :gutter="40">
      <table-chart
        :normal-span="12"
        canvasName="eventChart"
        :tableColumn="requestData && requestData.dimensions"
        :tableData="requestData && requestData.dataList"
        :chartOption="formatOption(requestData, 12)"
        :title="$t('事件统计')"
        color="#4EA8FF"
      ></table-chart>
    </el-row>
  </div>
</template>

<script>
import { dayTime, isEmpty } from '@/utils/utils.js';
import { statChart } from '@/echartOption/stat';
import { eventStatSever } from '@/api/air-monitor/stat';
import MForm from '@/components/form/index.vue';
import TableChart from '@/components/table-chart';
import { mapState } from 'vuex';

export default {
  components: {
    MForm,
    TableChart
  },
  data() {
    return {
      formModel: {
        eventTime: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      formConfig: {
        showClearable: true,
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              type: 'dateTimePicker',
              prop: 'eventTime',
              span: 8,
              label: this.$t('时间'),
              attrs: {
                type: 'datetimerange',
                valueFormat: 'timestamp'
              }
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async () => {
                  await this.loadChardDataHandle();
                }
              }
            ]
          }
        },

        dataSource: {
          eventList: []
        },
        rules: {}
      },
      showObj: null,
      requestData: null
    };
  },
  computed: {
    ...mapState('app', ['theme'])
  },
  mounted() {
    this.loadChardDataHandle();
  },
  methods: {
    loadChardDataHandle() {
      this.requestData = {
        dataList: [],
        dimensions: [],
        seriesData: []
      };
      let obj = {
        beginTime: this.formModel.eventTime[0],
        endTime: this.formModel.eventTime[1]
      };
      eventStatSever(obj).then(res => {
        if (res.code == 200) {
          let result = {};

          res.data.forEach(item => {
            result[item.eventTypeName] = item.number;
            this.requestData.dimensions.push(item.eventTypeName);
            this.requestData.seriesData.push(item.number);
          });

          this.requestData.dataList = [result];
        }
      });
    },

    formatOption(v) {
      if (isEmpty(v)) return;

      const { dimensions, seriesData } = v;

      let chartData = {
        xAxis: {
          type: 'category',
          data: dimensions,
          name: '事件类型'
        },
        yAxis: {
          type: 'value',
          name: '数值'
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            showBackground: true,
            barMaxWidth: 20,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      };

      return statChart(chartData, this.theme === 'light');
    }
  }
};
</script>

<style scoped lang="scss">
.event-stat-view {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  .chart-view {
    padding: 10px;
    height: 100%;
    display: flex;
    justify-content: center;
    .chart {
      height: 80% !important;
      width: 50% !important;
    }
  }
}
</style>
